import type { Step } from "react-joyride";

export const rolesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການບົດບາດ! ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການບົດບາດແລະສິດທິຂອງຜູ້ໃຊ້ໃນລະບົບ ທ່ານສາມາດສ້າງ, ແກ້ໄຂ, ຫຼືລຶບບົດບາດໄດ້. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="roles-toolbar"]',
    content: "ນີ້ແມ່ນປຸ່ມສ້າງບົດບາດໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງບົດບາດທີ່ທ່ານຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="roles-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາບົດບາດຕາມຊື່. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="roles-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງບົດບາດທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຫຼືລຶບບົດບາດໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະບົດບາດ. ທ່ານຍັງສາມາດຂະຫຍາຍແຖວເພື່ອເບິ່ງຄຳອະທິບາຍແລະສິດທິທັງໝົດ.",
    placement: "top",
  },
];
